import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import {} from '@frontend/design-system';

export const containerStyle = css`
  display: flex;
  gap: ${theme.spacing(2)};
  margin: ${theme.spacing(0, 2)};
`;

export const textContainerStyle = css`
  flex: 1;
  overflow: hidden;
`;

export const titleStyle = [];
